// 🔧 demo_sizes.js
// ✅ Purpose: Central demo size configuration for the LGV Demo Engine
// ✅ Features:
// - Defines entry, user, and vote volumes for each demo size
// - Keeps builder sizing consistent across categories, entries, users, and votes
// - Supports Phase 1 Core Package demo generation
// - Prepares future load-testing style demos
// - Fully block-commented for clarity and future devs

export const DEMO_SIZE_CONFIG = {
  small: {
    key: "small",
    label: "Small",
    entryCount: 10,
    userCount: 8,
    voteCount: 40,
    description: "Quick demo with a small number of entries.",
  },

  medium: {
    key: "medium",
    label: "Medium",
    entryCount: 50,
    userCount: 30,
    voteCount: 250,
    description: "Standard demo size for realistic event testing.",
  },

  large: {
    key: "large",
    label: "Large",
    entryCount: 200,
    userCount: 120,
    voteCount: 1000,
    description: "Larger Experience for load and workflow testing.",
  },
};

export const getDemoSizeConfig = (sizeKey = "small") => {
  return DEMO_SIZE_CONFIG[sizeKey] || DEMO_SIZE_CONFIG.small;
};
